module.exports = __webpack_public_path__ + "static/media/doc.e0791633.svg";